import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { DropdownPillMenu } from 'components/Dropdown';
import LINKS from 'constants/links';
import Message from 'components/Message';
import { reactHookFormPropTypes } from 'constants/propTypes';
import { buildSpotsDropdownOptions } from './SmartTools.helpers';

const MinimumSpotsItem = ({ control, label, info, schedule, name, className, showSelectOption }) => {
  const intl = useIntl();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const { value, onChange } = field;
        const options = buildSpotsDropdownOptions(intl, showSelectOption);
        return (
          <div className={className}>
            <div className="messages">
              <div className="item-name">
                <Message className="label" message={label} />
              </div>
              <Message className="info" message={info} />
            </div>
            <div className="button">
              <DropdownPillMenu
                attachment="left"
                items={options}
                getKey="key"
                getText="label"
                isSelected={({ key }) => key === value}
                onSelect={({ key }) => onChange(key)}
                renderSelectedItem={text => (text || text === 0 ? text : options[0].label)}
                renderAsActive={false}
                dataCypress={name}
              />
            </div>
            {schedule && (
              <Message
                className="schedule"
                message={schedule}
                values={{
                  strong: text => <strong>{text}</strong>,
                  a: text => (
                    <a href={LINKS.termsAdditionalDefinitions.href} target="_blank" rel="noopener noreferrer">
                      {text}
                    </a>
                  ),
                }}
              />
            )}
          </div>
        );
      }}
    />
  );
};

MinimumSpotsItem.propTypes = {
  control: reactHookFormPropTypes.control.isRequired,
  label: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  info: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  schedule: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  showSelectOption: PropTypes.bool.isRequired,
};

export default MinimumSpotsItem;
